import com.example.rhnaf.shared.model.*
import com.example.rhnaf.domain.model.*
import androidx.compose.runtime.*
import org.jetbrains.compose.web.dom.*
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.attributes.*
import io.ktor.client.*
import io.ktor.client.request.*
import io.ktor.client.call.*
import io.ktor.client.statement.*
import io.ktor.http.*
import kotlinx.coroutines.launch
import kotlinx.browser.window
import kotlinx.browser.document

fun fmt1(d: Double): String {
    val s = d.toString()
    val dot = s.indexOf('.')
    return if (dot >= 0 && dot + 2 < s.length) s.substring(0, dot + 2) else s
}
fun fmt2(d: Double): String {
    val s = d.toString()
    val dot = s.indexOf('.')
    return if (dot >= 0 && dot + 3 < s.length) s.substring(0, dot + 3) else s
}

enum class PreNominaTab { TURNOS, POLITICAS, ASIGNACIONES, JUSTIFICACIONES, CALCULO }

@Composable
fun PreNominaModule(client: HttpClient, scope: kotlinx.coroutines.CoroutineScope, t: Translations, userRole: UserRole) {
    val canEdit = userRole == UserRole.ADMIN || userRole == UserRole.RH
    var tab by remember { mutableStateOf(PreNominaTab.TURNOS) }

    Div({ style { backgroundColor(Color.white); padding(32.px); borderRadius(12.px); property("box-shadow", CardShadow) } }) {
        H3({ style { margin(0.px, 0.px, 4.px, 0.px) } }) { Text("Pre-Nómina") }
        P({ style { color(Color.gray); margin(0.px, 0.px, 16.px, 0.px); fontSize(14.px) } }) {
            Text("Gestión de turnos, políticas, incidencias y cálculo de pre-nómina")
        }

        Div({ style { display(DisplayStyle.Flex); gap(8.px); marginBottom(16.px); property("border-bottom", "1px solid #e2e8f0"); paddingBottom(8.px); flexWrap(FlexWrap.Wrap) } }) {
            listOf(
                PreNominaTab.TURNOS to "Turnos y Horarios",
                PreNominaTab.POLITICAS to "Políticas",
                PreNominaTab.ASIGNACIONES to "Asignación de Turnos",
                PreNominaTab.JUSTIFICACIONES to "Justificaciones",
                PreNominaTab.CALCULO to "Calcular Pre-Nómina"
            ).forEach { (tb, label) ->
                Button({
                    style {
                        padding(8.px, 16.px); borderRadius(6.px); property("border", "none"); cursor("pointer")
                        backgroundColor(if (tab == tb) SidebarActiveColor else Color("#f1f5f9"))
                        color(if (tab == tb) Color.white else Color("#334155"))
                        fontWeight("bold")
                    }
                    onClick { tab = tb }
                }) { Text(label) }
            }
        }

        when (tab) {
            PreNominaTab.TURNOS -> TurnosTab(client, scope, canEdit)
            PreNominaTab.POLITICAS -> PoliticasTab(client, scope, canEdit)
            PreNominaTab.ASIGNACIONES -> AsignacionesTab(client, scope, canEdit)
            PreNominaTab.JUSTIFICACIONES -> JustificacionesTab(client, scope, canEdit, userRole)
            PreNominaTab.CALCULO -> CalculoTab(client, scope, canEdit)
        }
    }
}

@Composable
fun TurnosTab(client: HttpClient, scope: kotlinx.coroutines.CoroutineScope, canEdit: Boolean) {
    var items by remember { mutableStateOf(emptyList<Shift>()) }
    var isLoading by remember { mutableStateOf(true) }
    var refreshKey by remember { mutableStateOf(0) }

    LaunchedEffect(refreshKey) {
        isLoading = true
        try { items = client.get("$BACKEND_URL/api/v1/pre-nomina/turnos").body() } catch (e: Exception) { println("Error: ${e.message}") }
        isLoading = false
    }

    var f_nombre by remember { mutableStateOf("") }
    var f_entrada by remember { mutableStateOf("") }
    var f_salida by remember { mutableStateOf("") }
    var f_tolerancia by remember { mutableStateOf("0") }
    var f_comida by remember { mutableStateOf("60") }
    var f_tipo by remember { mutableStateOf("Fijo") }
    var editando by remember { mutableStateOf<Shift?>(null) }

    if (canEdit) {
        Div({ style { display(DisplayStyle.Flex); gap(8.px); marginBottom(16.px); flexWrap(FlexWrap.Wrap); alignItems(AlignItems.Center) } }) {
            Input(InputType.Text) { placeholder("Nombre *"); value(f_nombre); onInput { f_nombre = it.value }; style { padding(8.px); borderRadius(6.px); property("border", "1px solid #cbd5e1"); width(180.px) } }
            Input(InputType.Text) { placeholder("Entrada HH:MM"); value(f_entrada); onInput { f_entrada = it.value }; style { padding(8.px); borderRadius(6.px); property("border", "1px solid #cbd5e1"); width(120.px) } }
            Input(InputType.Text) { placeholder("Salida HH:MM"); value(f_salida); onInput { f_salida = it.value }; style { padding(8.px); borderRadius(6.px); property("border", "1px solid #cbd5e1"); width(120.px) } }
            Input(InputType.Text) { placeholder("Tolerancia min"); value(f_tolerancia); onInput { f_tolerancia = it.value }; style { padding(8.px); borderRadius(6.px); property("border", "1px solid #cbd5e1"); width(100.px) } }
            Input(InputType.Text) { placeholder("Comida min"); value(f_comida); onInput { f_comida = it.value }; style { padding(8.px); borderRadius(6.px); property("border", "1px solid #cbd5e1"); width(100.px) } }
            Select({ style { padding(8.px); borderRadius(6.px); property("border", "1px solid #cbd5e1") }; onChange { f_tipo = (it.target as org.w3c.dom.HTMLSelectElement).value } }) {
                Option("Fijo") { Text("Fijo") }; Option("Quebrado") { Text("Quebrado") }; Option("Rotativo") { Text("Rotativo") }; Option("24h") { Text("24h") }
            }
            Button({
                style { padding(8.px, 16.px); backgroundColor(SidebarActiveColor); color(Color.white); property("border", "none"); borderRadius(6.px); cursor("pointer") }
                onClick {
                    if (f_nombre.isNotBlank() && f_entrada.isNotBlank() && f_salida.isNotBlank()) {
                        scope.launch {
                            client.post("$BACKEND_URL/api/v1/pre-nomina/turnos") {
                                contentType(ContentType.Application.Json)
                                setBody(Shift(nombre = f_nombre, horaEntrada = f_entrada, horaSalida = f_salida, minutoTolerancia = f_tolerancia.toIntOrNull() ?: 0, minutosComida = f_comida.toIntOrNull() ?: 60, tipoTurno = f_tipo))
                            }
                            f_nombre = ""; f_entrada = ""; f_salida = ""; f_tolerancia = "0"; f_comida = "60"; f_tipo = "Fijo"
                            refreshKey++
                        }
                    }
                }
            }) { Text("+ Agregar Turno") }
        }
    }

    if (isLoading) { P { Text("Cargando...") } } else {
        Table({ style { width(100.percent) } }) {
            Thead { Tr { Th { Text("Nombre") }; Th { Text("Entrada") }; Th { Text("Salida") }; Th { Text("Tolerancia") }; Th { Text("Comida") }; Th { Text("Tipo") }; if (canEdit) Th { Text("") } } }
            Tbody {
                items.forEach { s ->
                    Tr {
                        Td { Text(s.nombre) }; Td { Text(s.horaEntrada) }; Td { Text(s.horaSalida) }
                        Td { Text("${s.minutoTolerancia} min") }; Td { Text("${s.minutosComida} min") }; Td { Text(s.tipoTurno) }
                        if (canEdit) Td {
                            Button({ style { backgroundColor(Color("#337ab7")); color(Color.white); property("border", "none"); borderRadius(4.px); padding(4.px, 10.px); cursor("pointer"); marginRight(4.px) }
                                onClick { editando = s }
                            }) { Text("Editar") }
                            Button({ style { backgroundColor(Color("#ef4444")); color(Color.white); property("border", "none"); borderRadius(4.px); padding(4.px, 10.px); cursor("pointer") }
                                onClick { scope.launch { client.delete("$BACKEND_URL/api/v1/pre-nomina/turnos/${s.id}"); refreshKey++ } }
                            }) { Text("Eliminar") }
                        }
                    }
                }
            }
        }
    }

    // --- DIALOG: Editar turno ---
    editando?.let { s ->
        var e_nombre by remember(s.id) { mutableStateOf(s.nombre) }
        var e_entrada by remember(s.id) { mutableStateOf(s.horaEntrada) }
        var e_salida by remember(s.id) { mutableStateOf(s.horaSalida) }
        var e_tolerancia by remember(s.id) { mutableStateOf(s.minutoTolerancia.toString()) }
        var e_comida by remember(s.id) { mutableStateOf(s.minutosComida.toString()) }
        var e_tipo by remember(s.id) { mutableStateOf(if (s.tipoTurno.isBlank()) "Fijo" else s.tipoTurno) }
        Div({
            style {
                position(Position.Fixed); top(0.px); left(0.px); width(100.vw); height(100.vh)
                backgroundColor(Color("rgba(0,0,0,0.5)")); display(DisplayStyle.Flex)
                alignItems(AlignItems.Center); justifyContent(JustifyContent.Center); property("z-index", "999")
            }
        }) {
            Div({ style { backgroundColor(Color.white); borderRadius(12.px); padding(28.px); width(440.px); maxWidth("90vw") } }) {
                H4({ style { margin(0.px, 0.px, 4.px, 0.px) } }) { Text("Editar Turno") }
                P({ style { color(Color.gray); margin(0.px, 0.px, 16.px, 0.px); fontSize(13.px) } }) {
                    Text("Los cambios aplican al c\u00e1lculo de pre-n\u00f3mina en el siguiente rec\u00e1lculo del periodo.")
                }
                Input(InputType.Text) { placeholder("Nombre"); value(e_nombre); onInput { e_nombre = it.value }; style { padding(8.px); borderRadius(6.px); property("border", "1px solid #cbd5e1"); width(100.percent); marginBottom(8.px) } }
                Input(InputType.Text) { placeholder("Entrada HH:MM"); value(e_entrada); onInput { e_entrada = it.value }; style { padding(8.px); borderRadius(6.px); property("border", "1px solid #cbd5e1"); width(100.percent); marginBottom(8.px) } }
                Input(InputType.Text) { placeholder("Salida HH:MM"); value(e_salida); onInput { e_salida = it.value }; style { padding(8.px); borderRadius(6.px); property("border", "1px solid #cbd5e1"); width(100.percent); marginBottom(8.px) } }
                Input(InputType.Text) { placeholder("Tolerancia min"); value(e_tolerancia); onInput { e_tolerancia = it.value }; style { padding(8.px); borderRadius(6.px); property("border", "1px solid #cbd5e1"); width(100.percent); marginBottom(8.px) } }
                Input(InputType.Text) { placeholder("Comida min"); value(e_comida); onInput { e_comida = it.value }; style { padding(8.px); borderRadius(6.px); property("border", "1px solid #cbd5e1"); width(100.percent); marginBottom(8.px) } }
                Input(InputType.Text) { placeholder("Tipo (Fijo/Quebrado/Rotativo/24h)"); value(e_tipo); onInput { e_tipo = it.value }; style { padding(8.px); borderRadius(6.px); property("border", "1px solid #cbd5e1"); width(100.percent); marginBottom(8.px) } }
                Div({ style { display(DisplayStyle.Flex); gap(8.px); justifyContent(JustifyContent.End); marginTop(16.px) } }) {
                    Button({ style { padding(8.px, 16.px); borderRadius(6.px); property("border", "1px solid #cbd5e1"); backgroundColor(Color.white); color(Color("#334155")); cursor("pointer") }
                        onClick { editando = null }
                    }) { Text("Cancelar") }
                    Button({ style { padding(8.px, 16.px); borderRadius(6.px); property("border", "none"); backgroundColor(SidebarActiveColor); color(Color.white); cursor("pointer"); fontWeight("bold") }
                        onClick {
                            if (e_nombre.isNotBlank() && e_entrada.isNotBlank() && e_salida.isNotBlank()) {
                                scope.launch {
                                    try {
                                        client.put("$BACKEND_URL/api/v1/pre-nomina/turnos/${s.id}") {
                                            contentType(ContentType.Application.Json)
                                            setBody(Shift(id = s.id, nombre = e_nombre, horaEntrada = e_entrada, horaSalida = e_salida, minutoTolerancia = e_tolerancia.toIntOrNull() ?: 0, minutosComida = e_comida.toIntOrNull() ?: 60, tipoTurno = e_tipo))
                                        }
                                    } catch (e: Exception) { println("Error editando turno: ${e.message}") }
                                    editando = null
                                    refreshKey++
                                }
                            }
                        }
                    }) { Text("Guardar Cambios") }
                }
            }
        }
    }
}

@Composable
fun PoliticasTab(client: HttpClient, scope: kotlinx.coroutines.CoroutineScope, canEdit: Boolean) {
    var items by remember { mutableStateOf(emptyList<AttendancePolicy>()) }
    var isLoading by remember { mutableStateOf(true) }
    var refreshKey by remember { mutableStateOf(0) }

    LaunchedEffect(refreshKey) {
        isLoading = true
        try { items = client.get("$BACKEND_URL/api/v1/pre-nomina/politicas").body() } catch (e: Exception) { println("Error: ${e.message}") }
        isLoading = false
    }

    var f_nombre by remember { mutableStateOf("") }
    var f_tolRet by remember { mutableStateOf("5") }
    var f_retMayor by remember { mutableStateOf("15") }
    var f_salAnt by remember { mutableStateOf("5") }
    var f_extraInicio by remember { mutableStateOf("") }
    var f_primaDom by remember { mutableStateOf("0.25") }
    var f_descanso by remember { mutableStateOf("6") }

    if (canEdit) {
        Div({ style { display(DisplayStyle.Flex); gap(8.px); marginBottom(16.px); flexWrap(FlexWrap.Wrap); alignItems(AlignItems.Center) } }) {
            Input(InputType.Text) { placeholder("Nombre politica"); value(f_nombre); onInput { f_nombre = it.value }; style { padding(8.px); borderRadius(6.px); property("border", "1px solid #cbd5e1"); width(160.px) } }
            Input(InputType.Text) { placeholder("Tol. retardo min"); value(f_tolRet); onInput { f_tolRet = it.value }; style { padding(8.px); borderRadius(6.px); property("border", "1px solid #cbd5e1"); width(100.px) } }
            Input(InputType.Text) { placeholder("Retardo mayor min"); value(f_retMayor); onInput { f_retMayor = it.value }; style { padding(8.px); borderRadius(6.px); property("border", "1px solid #cbd5e1"); width(100.px) } }
            Input(InputType.Text) { placeholder("Salida ant. min"); value(f_salAnt); onInput { f_salAnt = it.value }; style { padding(8.px); borderRadius(6.px); property("border", "1px solid #cbd5e1"); width(100.px) } }
            Input(InputType.Text) { placeholder("Inicio extra HH:MM"); value(f_extraInicio); onInput { f_extraInicio = it.value }; style { padding(8.px); borderRadius(6.px); property("border", "1px solid #cbd5e1"); width(140.px) } }
            Input(InputType.Text) { placeholder("Prima dominical"); value(f_primaDom); onInput { f_primaDom = it.value }; style { padding(8.px); borderRadius(6.px); property("border", "1px solid #cbd5e1"); width(100.px) } }
            Input(InputType.Text) { placeholder("Dias descanso 0=D,6=S"); value(f_descanso); onInput { f_descanso = it.value }; style { padding(8.px); borderRadius(6.px); property("border", "1px solid #cbd5e1"); width(140.px) } }
            Button({
                style { padding(8.px, 16.px); backgroundColor(SidebarActiveColor); color(Color.white); property("border", "none"); borderRadius(6.px); cursor("pointer") }
                onClick {
                    if (f_nombre.isNotBlank()) {
                        scope.launch {
                            client.post("$BACKEND_URL/api/v1/pre-nomina/politicas") {
                                contentType(ContentType.Application.Json)
                                setBody(AttendancePolicy(nombre = f_nombre, toleranciaRetardoMin = f_tolRet.toIntOrNull() ?: 5, retardoMayorMin = f_retMayor.toIntOrNull() ?: 15, salidaAnticipadaMin = f_salAnt.toIntOrNull() ?: 5, horasExtraInicio = f_extraInicio, primaDominical = f_primaDom.toDoubleOrNull() ?: 0.25, diasDescanso = f_descanso))
                            }
                            f_nombre = ""; refreshKey++
                        }
                    }
                }
            }) { Text("+ Agregar Politica") }
        }
    }

    if (isLoading) { P { Text("Cargando...") } } else {
        Table({ style { width(100.percent) } }) {
            Thead { Tr { Th { Text("Nombre") }; Th { Text("Tol. Retardo") }; Th { Text("Ret. Mayor") }; Th { Text("Salida Ant.") }; Th { Text("Inicio Extra") }; Th { Text("Prima Dom.") }; Th { Text("Dias Descanso") }; if (canEdit) Th { Text("") } } }
            Tbody {
                items.forEach { p ->
                    Tr {
                        Td { Text(p.nombre) }; Td { Text("${p.toleranciaRetardoMin} min") }; Td { Text("${p.retardoMayorMin} min") }
                        Td { Text("${p.salidaAnticipadaMin} min") }; Td { Text(p.horasExtraInicio.ifBlank { "—" }) }
                        Td { Text("${(p.primaDominical * 100).toInt()}%") }; Td { Text(p.diasDescanso) }
                        if (canEdit) Td {
                            Button({ style { backgroundColor(Color("#ef4444")); color(Color.white); property("border", "none"); borderRadius(4.px); padding(4.px, 10.px); cursor("pointer") }
                                onClick { scope.launch { client.delete("$BACKEND_URL/api/v1/pre-nomina/politicas/${p.id}"); refreshKey++ } }
                            }) { Text("Eliminar") }
                        }
                    }
                }
            }
        }
    }
}

@Composable
fun AsignacionesTab(client: HttpClient, scope: kotlinx.coroutines.CoroutineScope, canEdit: Boolean) {
    var items by remember { mutableStateOf(emptyList<EmployeeShiftAssignment>()) }
    var shifts by remember { mutableStateOf(emptyList<Shift>()) }
    var employees by remember { mutableStateOf(emptyList<Employee>()) }
    var isLoading by remember { mutableStateOf(true) }
    var refreshKey by remember { mutableStateOf(0) }

    LaunchedEffect(refreshKey) {
        isLoading = true
        try {
            items = client.get("$BACKEND_URL/api/v1/pre-nomina/asignaciones").body()
            shifts = client.get("$BACKEND_URL/api/v1/pre-nomina/turnos").body()
            employees = client.get("$BACKEND_URL/api/employees").body()
        } catch (e: Exception) { println("Error: ${e.message}") }
        isLoading = false
    }

    var f_empId by remember { mutableStateOf("") }
    var f_shiftId by remember { mutableStateOf("") }

    if (canEdit) {
        Div({ style { display(DisplayStyle.Flex); gap(8.px); marginBottom(16.px); alignItems(AlignItems.Center) } }) {
            Select({ style { padding(8.px); borderRadius(6.px); property("border", "1px solid #cbd5e1"); width(250.px) }; onChange { f_empId = (it.target as org.w3c.dom.HTMLSelectElement).value } }) {
                Option("") { Text("Seleccionar empleado...") }
                employees.forEach { e -> Option(e.id) { Text("${e.firstName} ${e.lastName} (${e.id})") } }
            }
            Select({ style { padding(8.px); borderRadius(6.px); property("border", "1px solid #cbd5e1"); width(200.px) }; onChange { f_shiftId = (it.target as org.w3c.dom.HTMLSelectElement).value } }) {
                Option("") { Text("Seleccionar turno...") }
                shifts.forEach { s -> Option(s.id.toString()) { Text("${s.nombre} (${s.horaEntrada}-${s.horaSalida})") } }
            }
            Button({
                style { padding(8.px, 16.px); backgroundColor(SidebarActiveColor); color(Color.white); property("border", "none"); borderRadius(6.px); cursor("pointer") }
                onClick {
                    if (f_empId.isNotBlank() && f_shiftId.isNotBlank()) {
                        val emp = employees.find { it.id == f_empId }
                        val shift = shifts.find { it.id.toString() == f_shiftId }
                        scope.launch {
                            client.post("$BACKEND_URL/api/v1/pre-nomina/asignaciones") {
                                contentType(ContentType.Application.Json)
                                setBody(EmployeeShiftAssignment(employeeId = f_empId, employeeName = "${emp?.firstName} ${emp?.lastName}", shiftId = f_shiftId.toInt(), shiftName = shift?.nombre ?: "", fechaInicio = ""))
                            }
                            f_empId = ""; f_shiftId = ""; refreshKey++
                        }
                    }
                }
            }) { Text("+ Asignar") }
        }
    }

    if (isLoading) { P { Text("Cargando...") } } else {
        Table({ style { width(100.percent) } }) {
            Thead { Tr { Th { Text("Empleado") }; Th { Text("ID") }; Th { Text("Turno") }; Th { Text("Desde") }; if (canEdit) Th { Text("") } } }
            Tbody {
                items.forEach { a ->
                    Tr {
                        Td { Text(a.employeeName) }; Td { Text(a.employeeId) }; Td { Text(a.shiftName) }; Td { Text(a.fechaInicio) }
                        if (canEdit) Td {
                            Button({ style { backgroundColor(Color("#ef4444")); color(Color.white); property("border", "none"); borderRadius(4.px); padding(4.px, 10.px); cursor("pointer") }
                                onClick { scope.launch { client.delete("$BACKEND_URL/api/v1/pre-nomina/asignaciones/${a.id}"); refreshKey++ } }
                            }) { Text("Eliminar") }
                        }
                    }
                }
            }
        }
    }
}

@Composable
fun JustificacionesTab(client: HttpClient, scope: kotlinx.coroutines.CoroutineScope, canEdit: Boolean, userRole: UserRole) {
    var items by remember { mutableStateOf(emptyList<Justification>()) }
    var employees by remember { mutableStateOf(emptyList<Employee>()) }
    var isLoading by remember { mutableStateOf(true) }
    var refreshKey by remember { mutableStateOf(0) }

    LaunchedEffect(refreshKey) {
        isLoading = true
        try {
            items = client.get("$BACKEND_URL/api/v1/pre-nomina/justificaciones").body()
            employees = client.get("$BACKEND_URL/api/employees").body()
        } catch (e: Exception) { println("Error: ${e.message}") }
        isLoading = false
    }

    var f_empId by remember { mutableStateOf("") }
    var f_fecha by remember { mutableStateOf("") }
    var f_tipo by remember { mutableStateOf("Falta") }
    var f_motivo by remember { mutableStateOf("") }

    if (canEdit) {
        Div({ style { display(DisplayStyle.Flex); gap(8.px); marginBottom(16.px); flexWrap(FlexWrap.Wrap); alignItems(AlignItems.Center) } }) {
            Select({ style { padding(8.px); borderRadius(6.px); property("border", "1px solid #cbd5e1"); width(200.px) }; onChange { f_empId = (it.target as org.w3c.dom.HTMLSelectElement).value } }) {
                Option("") { Text("Empleado...") }
                employees.forEach { e -> Option(e.id) { Text("${e.firstName} ${e.lastName}") } }
            }
            Input(InputType.Date) { value(f_fecha); onInput { f_fecha = it.value }; style { padding(8.px); borderRadius(6.px); property("border", "1px solid #cbd5e1"); width(150.px) } }
            Select({ style { padding(8.px); borderRadius(6.px); property("border", "1px solid #cbd5e1") }; onChange { f_tipo = (it.target as org.w3c.dom.HTMLSelectElement).value } }) {
                Option("Falta") { Text("Falta") }; Option("Retardo") { Text("Retardo") }; Option("Salida anticipada") { Text("Salida anticipada") }
                Option("Permiso") { Text("Permiso") }; Option("Incapacidad") { Text("Incapacidad") }; Option("Vacaciones") { Text("Vacaciones") }
            }
            Input(InputType.Text) { placeholder("Motivo"); value(f_motivo); onInput { f_motivo = it.value }; style { padding(8.px); borderRadius(6.px); property("border", "1px solid #cbd5e1"); width(200.px) } }
            Button({
                style { padding(8.px, 16.px); backgroundColor(SidebarActiveColor); color(Color.white); property("border", "none"); borderRadius(6.px); cursor("pointer") }
                onClick {
                    if (f_empId.isNotBlank() && f_fecha.isNotBlank()) {
                        val emp = employees.find { it.id == f_empId }
                        scope.launch {
                            client.post("$BACKEND_URL/api/v1/pre-nomina/justificaciones") {
                                contentType(ContentType.Application.Json)
                                setBody(Justification(employeeId = f_empId, employeeName = "${emp?.firstName} ${emp?.lastName}", fecha = f_fecha, tipo = f_tipo, motivo = f_motivo, fechaSolicitud = ""))
                            }
                            f_empId = ""; f_fecha = ""; f_tipo = "Falta"; f_motivo = ""; refreshKey++
                        }
                    }
                }
            }) { Text("+ Nueva Justificacion") }
        }
    }

    if (isLoading) { P { Text("Cargando...") } } else {
        Table({ style { width(100.percent) } }) {
            Thead { Tr { Th { Text("Empleado") }; Th { Text("Fecha") }; Th { Text("Tipo") }; Th { Text("Motivo") }; Th { Text("Estado") }; Th { Text("Autorizado por") }; if (canEdit) Th { Text("") } } }
            Tbody {
                items.forEach { j ->
                    Tr {
                        Td { Text(j.employeeName) }; Td { Text(j.fecha) }; Td { Text(j.tipo) }; Td { Text(j.motivo) }
                        Td {
                            Span({ style {
                                padding(4.px, 8.px); borderRadius(4.px); fontSize(12.px); fontWeight("bold")
                                backgroundColor(when (j.estado) { "Aprobado" -> Color("#10b981"); "Rechazado" -> Color("#ef4444"); else -> Color("#f59e0b") })
                                color(Color.white)
                            } }) { Text(j.estado) }
                        }
                        Td { Text(j.autorizadoPor) }
                        if (canEdit) Td {
                            Div({ style { display(DisplayStyle.Flex); gap(4.px) } }) {
                                if (j.estado == "Pendiente") {
                                    Button({ style { backgroundColor(Color("#10b981")); color(Color.white); property("border", "none"); borderRadius(4.px); padding(4.px, 8.px); cursor("pointer"); fontSize(12.px) }
                                        onClick { scope.launch { client.put("$BACKEND_URL/api/v1/pre-nomina/justificaciones/${j.id}/aprobar") { contentType(ContentType.Application.Json); setBody(mapOf("autorizadoPor" to "Admin")) }; refreshKey++ } }
                                    }) { Text("Aprobar") }
                                    Button({ style { backgroundColor(Color("#ef4444")); color(Color.white); property("border", "none"); borderRadius(4.px); padding(4.px, 8.px); cursor("pointer"); fontSize(12.px) }
                                        onClick { scope.launch { client.put("$BACKEND_URL/api/v1/pre-nomina/justificaciones/${j.id}/rechazar") { contentType(ContentType.Application.Json); setBody(mapOf("observaciones" to "Rechazado")) }; refreshKey++ } }
                                    }) { Text("Rechazar") }
                                }
                                Button({ style { backgroundColor(Color("#6b7280")); color(Color.white); property("border", "none"); borderRadius(4.px); padding(4.px, 8.px); cursor("pointer"); fontSize(12.px) }
                                    onClick { scope.launch { client.delete("$BACKEND_URL/api/v1/pre-nomina/justificaciones/${j.id}"); refreshKey++ } }
                                }) { Text("Borrar") }
                            }
                        }
                    }
                }
            }
        }
    }
}

// Descarga los resultados calculados como CSV (abre directo en Excel).
// Se usa BOM UTF-8 para que Excel muestre bien los acentos.
fun descargarPreNominaCsv(items: List<PrePayrollRecord>) {
    if (items.isEmpty()) { window.alert("Primero calcula un periodo para poder descargarlo."); return }
    fun csv(v: String) = "\"" + v.replace("\"", "\"\"") + "\""
    val header = listOf("ID Empleado","Empleado","Periodo Inicio","Periodo Fin","Dias Trabajados","Faltas","Retardos Menores","Retardos Mayores","Salidas Anticipadas","Horas Trabajadas","Horas Extra","Prima Dominical","Dias Descanso Trabajados","Estado")
    val lines = StringBuilder()
    lines.append(header.joinToString(","))
    lines.append("\r\n")
    for (r in items) {
        lines.append(listOf(
            r.employeeId, r.employeeName, r.periodoInicio, r.periodoFin,
            r.diasTrabajados.toString(), r.faltas.toString(),
            r.retardosMenores.toString(), r.retardosMayores.toString(),
            r.salidasAnticipadas.toString(), r.horasTrabajadas.toString(),
            r.horasExtra.toString(), r.primaDominical.toString(),
            r.diasDescansoTrabajados.toString(), r.estado
        ).joinToString(",") { csv(it) })
        lines.append("\r\n")
    }
    val blob = org.w3c.files.Blob(arrayOf("\uFEFF" + lines.toString()))
    val url = window.asDynamic().URL.createObjectURL(blob) as String
    val a = kotlinx.browser.document.createElement("a") as org.w3c.dom.HTMLAnchorElement
    a.href = url
    val periodo = if (items.isNotEmpty()) items.first().periodoInicio + "_a_" + items.first().periodoFin else ""
    a.download = "pre_nomina_$periodo.csv"
    document.body?.appendChild(a)
    a.click()
    document.body?.removeChild(a)
    window.asDynamic().URL.revokeObjectURL(url)
}

@Composable
fun CalculoTab(client: HttpClient, scope: kotlinx.coroutines.CoroutineScope, canEdit: Boolean) {
    var items by remember { mutableStateOf(emptyList<PrePayrollRecord>()) }
    var isLoading by remember { mutableStateOf(false) }
    var isCalculating by remember { mutableStateOf(false) }
    var refreshKey by remember { mutableStateOf(0) }
    var f_inicio by remember { mutableStateOf("") }
    var f_fin by remember { mutableStateOf("") }
    var f_grupo by remember { mutableStateOf("Todos") }
    var ajusteEmp by remember { mutableStateOf<PrePayrollRecord?>(null) }
    var isDescargandoPdf by remember { mutableStateOf(false) }
    var f_diasTodos by remember { mutableStateOf("") }
    var ajustesExistentes by remember { mutableStateOf<Map<String, Map<String, String?>>>(emptyMap()) }

    // Se relanza tanto al presionar Calcular/Refrescar (refreshKey) como al cambiar
    // cualquier filtro (fecha inicio/fin o grupo), para que la tabla se actualice de
    // inmediato al elegir "Quincenal" sin tener que presionar otro boton.
    LaunchedEffect(refreshKey, f_inicio, f_fin, f_grupo) {
        isLoading = true
        try {
            // Filtra siempre por el periodo/grupo actualmente seleccionado, para que la
            // tabla no mezcle calculos viejos de otros periodos con el recien calculado.
            val qi = if (f_inicio.isNotBlank()) "&inicio=$f_inicio" else ""
            val qf = if (f_fin.isNotBlank()) "&fin=$f_fin" else ""
            val qg = if (f_grupo != "Todos") "&grupo=$f_grupo" else ""
            items = client.get("$BACKEND_URL/api/v1/pre-nomina/resultados?x=1$qi$qf$qg").body()
        } catch (e: Exception) { println("Error: ${e.message}") }
        isLoading = false
    }

    val totalEmpleados = items.map { it.employeeId }.distinct().size
    val totalFaltas = items.sumOf { it.faltas }
    val totalRetardos = items.sumOf { it.retardosMenores + it.retardosMayores }
    val totalHorasExtra = items.sumOf { it.horasExtra }

    Div({ style { display(DisplayStyle.Grid); property("grid-template-columns", "1fr 1fr 1fr 1fr"); gap(16.px); marginBottom(24.px) } }) {
        StatCard("Empleados en periodo", totalEmpleados.toString(), "Calculo de pre-nomina", SidebarActiveColor)
        StatCard("Total de faltas", totalFaltas.toString(), "Sin justificar", Color("#ef4444"))
        StatCard("Total de retardos", totalRetardos.toString(), "Menores + mayores", Color("#f59e0b"))
        StatCard("Horas extra total", fmt1(totalHorasExtra), "Acumuladas", Color("#10b981"))
    }

    Div({ style { display(DisplayStyle.Flex); gap(8.px); marginBottom(8.px); alignItems(AlignItems.Center); padding(10.px); backgroundColor(Color("#f8fafc")); borderRadius(8.px); property("border", "1px solid #e2e8f0") } }) {
        Text("Dias proyectados a pagar, aplicar a todos los empleados del periodo:")
        Input(InputType.Number) {
            placeholder("Dias (ej. 7 o 15)")
            onInput { f_diasTodos = it.value?.toString() ?: "" }
            style { padding(6.px); borderRadius(6.px); property("border", "1px solid #cbd5e1"); width(130.px) }
        }
        Button({
            style { padding(6.px, 14.px); backgroundColor(Color("#0f766e")); color(Color.white); property("border", "none"); borderRadius(6.px); cursor("pointer"); fontWeight("bold") }
            onClick {
                if (f_inicio.isNotBlank() && f_fin.isNotBlank() && f_diasTodos.isNotBlank()) {
                    scope.launch {
                        try {
                            client.post("$BACKEND_URL/api/v1/pre-nomina/ajuste-masivo") {
                                contentType(ContentType.Application.Json)
                                setBody(mapOf(
                                    "periodoInicio" to f_inicio, "periodoFin" to f_fin,
                                    "diasProyectados" to f_diasTodos, "updatedBy" to "RH"
                                ))
                            }
                            window.alert("Dias proyectados aplicados a todos los empleados del periodo.")
                            refreshKey++
                        } catch (e: Exception) { window.alert("Error: ${e.message}") }
                    }
                } else { window.alert("Primero elige el periodo (fechas) y captura los dias.") }
            }
        }) { Text("Aplicar a todos") }
    }

    Div({ style { display(DisplayStyle.Flex); gap(8.px); marginBottom(16.px); alignItems(AlignItems.Center) } }) {
        // Selector nativo de fecha (calendario), igual que en el modulo de Asistencia.
        Input(InputType.Date) { value(f_inicio); onInput { f_inicio = it.value }; style { padding(8.px); borderRadius(6.px); property("border", "1px solid #cbd5e1"); width(160.px) } }
        Input(InputType.Date) { value(f_fin); onInput { f_fin = it.value }; style { padding(8.px); borderRadius(6.px); property("border", "1px solid #cbd5e1"); width(160.px) } }
        org.jetbrains.compose.web.dom.Select({
            style { padding(8.px); borderRadius(6.px); property("border", "1px solid #cbd5e1"); backgroundColor(Color.white); fontWeight("600") }
            onChange { f_grupo = it.value ?: "Todos" }
        }) {
            org.jetbrains.compose.web.dom.Option("Todos") { Text("Todos") }
            org.jetbrains.compose.web.dom.Option("Semanal") { Text("Semanal") }
            org.jetbrains.compose.web.dom.Option("Quincenal") { Text("Quincenal") }
        }
        Button({
            style { padding(8.px, 12.px); backgroundColor(Color("#7c3aed")); color(Color.white); property("border", "none"); borderRadius(6.px); cursor("pointer"); fontSize(11.px); fontWeight("bold") }
            onClick {
                scope.launch {
                    try {
                        val resp: String = client.post("$BACKEND_URL/api/v1/pre-nomina/frecuencias/auto").body()
                        window.alert("Frecuencia de pago reasignada por departamento. $resp")
                        refreshKey++
                    } catch (e: Exception) { window.alert("Error: ${e.message}") }
                }
            }
        }) { Text("Frec. x dept") }
        Button({
            style { padding(8.px, 16.px); backgroundColor(if (isCalculating) Color.gray else SidebarActiveColor); color(Color.white); property("border", "none"); borderRadius(6.px); cursor("pointer"); fontWeight("bold") }
            onClick {
                if (f_inicio.isNotBlank() && f_fin.isNotBlank()) {
                    isCalculating = true
                    scope.launch {
                        try {
                            val resp: String = client.post("$BACKEND_URL/api/v1/pre-nomina/calcular?inicio=$f_inicio&fin=$f_fin&grupo=$f_grupo").body()
                            println("Calcular response: $resp")
                            refreshKey++
                        } catch (e: Exception) { window.alert("Error: ${e.message}") }
                        finally { isCalculating = false }
                    }
                }
            }
        }) { Text(if (isCalculating) "Calculando..." else "Calcular Pre-Nomina") }
        Button({
            style { padding(8.px, 16.px); backgroundColor(Color("#475569")); color(Color.white); property("border", "none"); borderRadius(6.px); cursor("pointer") }
            onClick { refreshKey++ }
        }) { Text("Refrescar") }
        Button({
            style { padding(8.px, 16.px); backgroundColor(Color("#16a34a")); color(Color.white); property("border", "none"); borderRadius(6.px); cursor("pointer"); fontWeight("bold") }
            onClick { descargarPreNominaCsv(items) }
        }) { Text("Descargar CSV") }
        Button({
            style { padding(8.px, 16.px); backgroundColor(Color("#2563eb")); color(Color.white); property("border", "none"); borderRadius(6.px); cursor("pointer"); fontWeight("bold") }
            onClick {
                if (items.isNotEmpty() && !isDescargandoPdf) {
                    scope.launch {
                        isDescargandoPdf = true
                        try {
                            val resp = client.get("$BACKEND_URL/api/v1/pre-nomina/pdf?inicio=$f_inicio&fin=$f_fin&grupo=$f_grupo")
                            if (resp.status == HttpStatusCode.OK) {
                                val bytes = resp.readBytes()
                                val blob = org.w3c.files.Blob(arrayOf(bytes))
                                val url = window.asDynamic().URL.createObjectURL(blob) as String
                                val a = document.createElement("a") as org.w3c.dom.HTMLAnchorElement
                                a.href = url
                                a.download = "pre_nomina_${f_inicio}_a_${f_fin}.pdf"
                                document.body?.appendChild(a)
                                a.click()
                                document.body?.removeChild(a)
                                window.asDynamic().URL.revokeObjectURL(url)
                            } else {
                                window.alert("No hay pre-nomina calculada para ese periodo. Calcula primero.")
                            }
                        } catch (e: Exception) {
                            window.alert("Error al generar PDF: ${e.message}")
                        } finally {
                            isDescargandoPdf = false
                        }
                    }
                }
            }
        }) { Text(if (isDescargandoPdf) "Generando..." else "Descargar PDF") }
        if (canEdit && items.isNotEmpty()) {
            Button({
                style { padding(8.px, 16.px); backgroundColor(Color("#ef4444")); color(Color.white); property("border", "none"); borderRadius(6.px); cursor("pointer") }
                onClick { scope.launch { client.delete("$BACKEND_URL/api/v1/pre-nomina/resultados/bulk/all"); refreshKey++ } }
            }) { Text("Borrar resultados") }
        }
    }

    if (isLoading) { P { Text("Cargando...") } } else if (items.isEmpty()) {
        P({ style { color(Color.gray); textAlign("center"); padding(32.px, 0.px) } }) { Text("No hay resultados calculados. Selecciona un periodo y presiona Calcular Pre-Nomina.") }
    } else {
        Table({ style { width(100.percent); fontSize(13.px) } }) {
            Thead {
                Tr { Th { Text("Empleado") }; Th { Text("Periodo") }; Th { Text("Dias Trab.") }; Th { Text("Faltas") }; Th { Text("Ret.Men.") }; Th { Text("Ret.May.") }; Th { Text("Sal.Ant.") }; Th { Text("Hrs.Trab.") }; Th { Text("Hrs.Extra") }; Th { Text("Prima Dom.") }; Th { Text("Dias Desc.") }; if (canEdit) Th { Text("") } }
            }
            Tbody {
                items.forEach { r ->
                    val aj = ajustesExistentes[r.employeeId]
                    Tr {
                        Td { Text(r.employeeName) }; Td { Text("${r.periodoInicio} a ${r.periodoFin}") }
                        Td { Text(r.diasTrabajados.toString()) }
                        Td { if (r.faltas > 0) Span({ style { color(Color("#ef4444")); fontWeight("bold") } }) { Text(r.faltas.toString()) } else Text("0") }
                        Td { Text(r.retardosMenores.toString()) }; Td { Text(r.retardosMayores.toString()) }; Td { Text(r.salidasAnticipadas.toString()) }
                        Td { Text(fmt1(r.horasTrabajadas)) }
                        Td { if (r.horasExtra > 0) Span({ style { color(Color("#10b981")); fontWeight("bold") } }) { Text(fmt1(r.horasExtra)) } else Text("0") }
                        Td { Text(fmt2(r.primaDominical)) }; Td { Text(r.diasDescansoTrabajados.toString()) }
                        if (canEdit) Td({ style { whiteSpace("nowrap") } }) {
                            if (aj != null) Span({ style { fontSize(10.px); backgroundColor(Color("#fef3c7")); color(Color("#92400e")); padding(2.px, 6.px); borderRadius(4.px); marginRight(4.px) } }) { Text("AJUSTADO") }
                            Button({ style { backgroundColor(Color("#2563eb")); color(Color.white); property("border", "none"); borderRadius(4.px); padding(4.px, 10.px); cursor("pointer") }
                                onClick {
                                    ajusteEmp = r
                                    scope.launch {
                                        try {
                                            val resp: List<Map<String, String?>> = client.get("$BACKEND_URL/api/v1/pre-nomina/ajustes?inicio=${r.periodoInicio}&fin=${r.periodoFin}").body()
                                            ajustesExistentes = resp.associate { (it["employeeId"] ?: "") to it }
                                        } catch (e: Exception) { }
                                    }
                                }
                            }) { Text("Ajustar") }
                            Button({ style { backgroundColor(Color("#ef4444")); color(Color.white); property("border", "none"); borderRadius(4.px); padding(4.px, 10.px); cursor("pointer") }
                                onClick { scope.launch { client.delete("$BACKEND_URL/api/v1/pre-nomina/resultados/${r.id}"); refreshKey++ } }
                            }) { Text("Eliminar") }
                        }
                    }
                }
            }
        }
    }

    // --- DIALOG: Ajustar deducciones (ISR/IMSS/anticipos) ---
    val ajusteRec = ajusteEmp
    if (ajusteRec != null) {
        val ajEx = ajustesExistentes[ajusteRec.employeeId]
        var vIsr by remember(ajusteRec.id) { mutableStateOf(ajEx?.get("isr") ?: "") }
        var vImss by remember(ajusteRec.id) { mutableStateOf(ajEx?.get("imss") ?: "") }
        var vAnticipo by remember(ajusteRec.id) { mutableStateOf(ajEx?.get("anticipo") ?: "") }
        var vOtros by remember(ajusteRec.id) { mutableStateOf(ajEx?.get("otros") ?: "") }
        var vInfonavit by remember(ajusteRec.id) { mutableStateOf(ajEx?.get("infonavit") ?: "") }
        var vFondoAhorro by remember(ajusteRec.id) { mutableStateOf(ajEx?.get("fondoAhorro") ?: "") }
        var vFonacot by remember(ajusteRec.id) { mutableStateOf(ajEx?.get("fonacot") ?: "") }
        var vDiasProyectados by remember(ajusteRec.id) { mutableStateOf(ajEx?.get("diasProyectados")?.takeIf { it != "0" } ?: "") }
        var guardando by remember { mutableStateOf(false) }
        Div({
            style {
                position(Position.Fixed); top(0.px); left(0.px); width(100.vw); height(100.vh)
                backgroundColor(Color("rgba(0,0,0,0.5)")); display(DisplayStyle.Flex)
                alignItems(AlignItems.Center); justifyContent(JustifyContent.Center); property("z-index", "999")
            }
        }) {
            Div({ style { backgroundColor(Color.white); borderRadius(12.px); padding(28.px); width(440.px); maxWidth("90vw") } }) {
                H3({ style { margin(0.px, 0.px, 6.px, 0.px) } }) { Text("Ajustar deducciones") }
                P({ style { fontSize(12.px); color(Color("#64748b")); margin(0.px, 0.px, 16.px, 0.px) } }) {
                    Text("${ajusteRec.employeeName} (${ajusteRec.periodoInicio} a ${ajusteRec.periodoFin})")
                }
                P({ style { fontSize(11.px); color(Color("#92400e")); backgroundColor(Color("#fef3c7")); padding(8.px, 10.px); borderRadius(6.px); margin(0.px, 0.px, 12.px, 0.px) } }) {
                    Text("Deja un campo vacio para usar el calculo automatico de ISR/IMSS.")
                }
                EditField("ISR (retencion) - vacio = automatico", vIsr) { vIsr = it }
                EditField("IMSS (cuota obrera) - vacio = automatico", vImss) { vImss = it }
                P({ style { fontSize(11.px); color(Color("#64748b")); margin(4.px, 0.px, 8.px, 0.px) } }) { Text("Cesantia y vejez se calcula automaticamente (no se edita aqui).") }
                EditField("Infonavit - vacio = usa el monto de la ficha del empleado", vInfonavit) { vInfonavit = it }
                EditField("Fonacot - vacio = usa el monto de la ficha del empleado", vFonacot) { vFonacot = it }
                EditField("Fondo de ahorro (trabajador) - vacio = usa % de la ficha", vFondoAhorro) { vFondoAhorro = it }
                EditField("Anticipo de nomina", vAnticipo) { vAnticipo = it }
                EditField("Otros descuentos", vOtros) { vOtros = it }
                P({ style { fontSize(11.px); color(Color("#1e3a8a")); backgroundColor(Color("#dbeafe")); padding(8.px, 10.px); borderRadius(6.px); margin(8.px, 0.px, 0.px, 0.px) } }) {
                    Text("Si la nomina se envia antes de que termine el periodo (por ejemplo se calcula el 21 pero se paga hasta el 30), agrega aqui los dias estimados restantes para incluirlos en el pago.")
                }
                EditField("Dias proyectados a pagar (estimados)", vDiasProyectados) { vDiasProyectados = it }
                Div({ style { display(DisplayStyle.Flex); gap(12.px); marginTop(20.px) } }) {
                    Button({
                        style { flex(1); padding(10.px); borderRadius(8.px); property("border", "none"); backgroundColor(Color("#2563eb")); color(Color.white); cursor("pointer"); fontWeight("bold") }
                        onClick {
                            if (!guardando) {
                                guardando = true
                                scope.launch {
                                    try {
                                        client.post("$BACKEND_URL/api/v1/pre-nomina/ajuste") {
                                            contentType(ContentType.Application.Json)
                                            setBody(mapOf(
                                                "employeeId" to ajusteRec.employeeId,
                                                "periodoInicio" to ajusteRec.periodoInicio,
                                                "periodoFin" to ajusteRec.periodoFin,
                                                "isr" to vIsr, "imss" to vImss,
                                                "anticipo" to vAnticipo, "otros" to vOtros,
                                                "infonavit" to vInfonavit, "fondoAhorro" to vFondoAhorro, "fonacot" to vFonacot,
                                                "diasProyectados" to vDiasProyectados
                                            ))
                                        }
                                        // refrescar lista de ajustes
                                        val resp: List<Map<String, String?>> = client.get("$BACKEND_URL/api/v1/pre-nomina/ajustes?inicio=${ajusteRec.periodoInicio}&fin=${ajusteRec.periodoFin}").body()
                                        ajustesExistentes = resp.associate { (it["employeeId"] ?: "") to it }
                                    } catch (e: Exception) {
                                        window.alert("Error al guardar: ${e.message}")
                                    } finally {
                                        guardando = false
                                        ajusteEmp = null
                                    }
                                }
                            }
                        }
                    }) { Text(if (guardando) "Guardando..." else "Guardar ajuste") }
                    Button({
                        style { flex(1); padding(10.px); borderRadius(8.px); property("border", "1px solid #cbd5e1"); backgroundColor(Color.white); cursor("pointer") }
                        onClick { ajusteEmp = null }
                    }) { Text("Cancelar") }
                }
            }
        }
    }
}
